module.exports = __webpack_public_path__ + "img/ac25016b26b149f7b94a70127a3df9ec.112a14d5.png";